import { NewMetrics } from "../../interfaces/interfaces";

export const getMetricsObj = (metrics: NewMetrics[]) => {
  const data = recursiveFunc(metrics);
  return data;
};

const recursiveFunc = (metrics: NewMetrics[], prevObj = {}) => {
  return metrics.reduce((prev, curVal) => {
    prev[curVal.metricKey] = {
      ...curVal,
      sumMetricKey: null,
    };
    if (curVal.sumMetricKey) {
      prev[curVal.sumMetricKey] = curVal;
    }
    if (curVal.metrics && curVal.metrics.length > 0) {
      return recursiveFunc(curVal.metrics, prev);
    }
    return prev;
  }, prevObj);
};

export const getSelectedMetrics = (
  metrics: { [x: string]: NewMetrics },
  selectedMetrics: string[],
  dataAlertLabel: string
) => {
  const allMetrics = selectedMetrics.map((item, index) => {
    if (metrics[item] !== undefined) {
      let foundMetric: NewMetrics = metrics[item];
      // console.log("found Metric", foundMetric);
      let selectedMetric = "";
      if (foundMetric.isValue) {
        selectedMetric = `${item}_._All Metrics`;
      } else if (foundMetric.isLabel) {
        selectedMetric = dataAlertLabel
          ? foundMetric?.metrics
            ? `${foundMetric.metricKey}_._All Metrics`
            : `${foundMetric.metricKey}`
          : `${foundMetric.metricKey}`;
      } else if (
        foundMetric &&
        foundMetric.isDatasetLabel &&
        foundMetric.sumMetricKey == null
      ) {
        selectedMetric = `${foundMetric.metricKey}`;
      } else if (
        foundMetric &&
        foundMetric.isDatasetLabel &&
        foundMetric.sumMetricKey !== null
      ) {
        selectedMetric = `${foundMetric.sumMetricKey}_._All Metrics`;
      } else {
      }
      return {
        metricKey:
          item == foundMetric.sumMetricKey
            ? foundMetric.sumMetricKey
            : foundMetric.metricKey,
        title: foundMetric.title,
        isValue: foundMetric.isValue,
        isDatasetLabel: foundMetric.isDatasetLabel,
        isLabel: foundMetric.isLabel,
        isSum: item == foundMetric.sumMetricKey ? true : false,
        childMetricKey:
          foundMetric.metrics && foundMetric.metrics.length > 0
            ? foundMetric.metrics.map((item) => item.metricKey)
            : null,
        selectedMetric,
      };
    }
  });
  return allMetrics;
};
